import { Grid2 as Grid } from "@mui/material";
import { useMemo } from "react";
import { DetailsTree, DetailsTreeItemValue } from "@synota-io/synota-shared-ui";
import { InvoiceData } from "../../../../api/hooks/useInvoiceDetails";
import { scalarsToTree, intervalsToTree } from "../fields/invoiceTreeItems";

interface Props {
  data: InvoiceData;
}

export const InvoiceDetailsList = ({ data }: Props) => {
  const scalarsItems: DetailsTreeItemValue[] = useMemo(() => scalarsToTree(data), [data]);
  const intervalsItems: DetailsTreeItemValue[] = useMemo(() => intervalsToTree(data), [data]);
  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: 6 }}>
        <DetailsTree disablePaper defaultExpandedItems={["scalars_root"]} items={scalarsItems} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <DetailsTree
          disablePaper
          defaultExpandedItems={["intervals_root"]}
          items={intervalsItems}
        />
      </Grid>
    </Grid>
  );
};
